module.exports = __webpack_public_path__ + "img/check-purple.9224dcd5.svg";